<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="approve-title">
                {{ 'restore-version.confirmation.dialog.title' | translate }}
            </div>
            <div class="approve-message">
                {{ 'restore-version.confirmation.dialog.message' | translate }}
            </div>
            <div class="buttons-container">
                <div class="button" (click)="cancel()">
                    {{ 'restore-version.confirmation.dialog.button.cancel' | translate }}
                </div>
                <div class="restore button" (click)="restore()">
                    {{ 'restore-version.confirmation.dialog.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
